/**
 * Indicates the measurement method used to measure linear shrinkage
 */
export enum LinearShrinkageMeasureMethod {
  Longitudinal = 1,
  SoilBarLength = 2,
}

/**
 * Defines a list of methods that indicate what method was used for the Moisture Condition test
 */
export const MoistureContentMethodList = ['AS 1289.3.1.1', 'AS 1289.3.1.2', 'AS 1289.3.9.1', 'AS 1289.3.9.2', 'Other'];
